<template>
  <div class="page-draw">
    <div class="position-wrap">
      <div class="scroll-tips">
        <div class="content">
          <p class="block animate">
            <span>136xxxx1149抽中了 价值30元礼品券</span>
            <span>189xxxx8652抽中了 200元现金抵扣券</span>
          </p>
          <p class="block">
            <span>136xxxx1149抽中了 价值30元礼品券</span>
            <span>189xxxx8652抽中了 200元现金抵扣券</span>
          </p>
        </div>
      </div>
      <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/1.png"/>
      <img @click="toPage(7)" class="award-entrance" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/19.png"/>
      <div class="pot-wrap" :class="{animate:drawing}">
        <img class="gachapon pos1" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/3.png"/>
        <img class="gachapon pos2" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/4.png"/>
        <img class="gachapon pos3" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/5.png"/>
        <img class="gachapon pos4" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/3.png"/>
        <img class="gachapon pos5" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/4.png"/>
        <img class="gachapon pos6" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/5.png"/>
        <img class="gachapon pos7" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/5.png"/>
      </div>
      <img class="pot-base" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/6.png"/>
      <img class="float-wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/7.png"/>
      <img @click="startDraw" class="start-btn" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/8.png"/>
    </div>
    <!-- 抽奖结果 -->
    <div class="result-dialog-shadow" v-if="resultResultVisible"></div>
    <div class="result-dialog" v-if="resultResultVisible">
      <img class="banner" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/banner1.png"/>
      <div class="content" v-show="resultResultData.type==='success'">
        <p class="title">恭喜您<br/>中了<span>幸运奖品</span></p>
        <img class="cover" :src="resultResultData.cover"/>
        <div class="smile">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/smile.png"/>
        </div>
        <p class="name">{{ resultResultData.name }}</p>
        <img class="btn" @click="toPage(4)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/get-now.png"/>
      </div>
      <div class="content" v-show="resultResultData.type==='fail'">
        <p class="title wid">很遗憾！<br/>与奖品擦肩而过!</p>
        <div class="cry">
          <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/cry.png"/>
        </div>
        <img class="btn" @click="subscribeDialogVisible=true" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/focus-us.png"/>
        <p class="focus-tips">(请关注我们，更多活动及时通知)</p>
      </div>
      <img class="back-btn" @click="toPage(0)" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/back-home.png"/>
    </div>
    <!-- 关注弹窗 -->
    <subscribe-dialog v-show="subscribeDialogVisible" @close="subscribeDialogVisible=false"></subscribe-dialog>
  </div>
</template>
<script>
import subscribeDialog from "./subscribe.vue";
export default {
  components:{
    subscribeDialog
  },
  props:['pageStep','activityId','orgId'],
  data(){
    return {
      subscribeDialogVisible: false,
      drawing: false,// 抽奖动画
      resultResultVisible: false,//结果弹窗
      resultResultData:{
        type: '',
        name: '',
        cover: ''
      },
      lotteryNum: 0,// 用户可抽奖次数
    };
  },
  watch:{
    pageStep(n){
      if(n===1){
        this.getActivityInfo();
      }
    }
  },
  created(){
    this.getActivityInfo();
  },
  methods:{
    getActivityInfo(){
      if(!this.activityId){
        return false;
      }
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/lottery/get_user_lottery_num`,
        method: "post",
        params:{
          source_type: 1,
          activity_id: this.activityId
        }
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.lotteryNum = res.data.data.lottery_num;
        }else{
          this.$toast(res.data.message);
        }
      });
    },
    toPage(i){
      this.$emit('update:pageStep',i);
    },
    startDraw(){
      // 检查抽奖次数
      if(this.lotteryNum===0){
        this.$toast('已无抽奖次数');
        return false;
      }
      // 开始动画
      this.drawing = true;
      // 发送抽奖请求
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/lottery`,
        method: "post",
        params:{
          source_type: 1,
          activity_id: this.activityId,
          channel: this.orgId
        }
      }).then((res) => {
        if (res.data.error_code === 0) {
          // 延迟2s展示结果（保证动画时长）
          setTimeout(()=>{
            this.drawing = false;
            // 展示结果
            this.resultResultVisible = true;
            this.resultResultData = {
              type:res.data.data.is_lucky===1?'success':'fail',
              name:res.data.data.prize_title,
              cover:res.data.data.prize_cover_image_url
            };
          },2100);
        }else{
          this.$toast(res.data.message);
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.page-draw{
  height: 100vh;
  min-height: 669px;
  overflow: hidden;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/11.png);
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  text-align: center;
  .position-wrap{
    height: 669px;
    width: 100vw;
    position: absolute;
    top:50%;
    left:0;
    transform: translate(0,-50%);
  }
  .scroll-tips{
    position: absolute;
    z-index: 1000;
    top:8px;
    left: 39px;
    right: 39px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.32);
    padding:6px 13px;
    .content{
      white-space: nowrap;
      overflow: hidden;
      .block{
        display: inline-block;
        span{
          font-size: 12px;
          color: #fff;
          line-height: 17px;
          margin-right: 10px;
        }
      }
      .animate{
        animation: logScroll 12s infinite linear;
      }
    }
  }
  .top-title{
    position: absolute;
    z-index: 10000;
    top:20px;
    left:0;
    right:0;
    width: 353px;
    height:auto;
    display: block;
    margin:0 auto;
  }
  .award-entrance{
    position: absolute;
    z-index: 10030;
    top:177px;
    right:-3px;
    width: 50px;
    height: auto;
  }
  .pot-wrap{
    width: 340px;
    height: 342px;
    background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/2.png);
    background-position: center top;
    background-size: 100% 100%;
    position: absolute;
    top: 100px;
    left: 24px;
    z-index: 10001;
    &.animate{
      .gachapon{
        animation-name: lotteryJumping;
        animation-duration : 1s;
        animation-timing-function: linear;
        animation-name: lotteryJumping;
        animation-name: lotteryJumping;
        &.pos1{
          animation-delay: 0.1s;
        }
        &.pos2{
          animation-delay: 0.08s;
        }
        &.pos3{
          animation-delay: 0.06s;
        }
        &.pos4{
          animation-delay: 0.04s;
        }
        &.pos5{
          animation-delay: 0.02s;
        }
        &.pos6{
          animation-delay: 0.04s;
        }
        &.pos7{
          animation-delay: 0.06s;
        }
      }
    }
    .gachapon{
      position: relative;
      height: 53px;
      width: 53px;
    }
    .pos1{
      position: absolute;
      top:255px;
      left:120px;
      transform: rotate(-5deg);
    }
    .pos2{
      position: absolute;
      top:210px;
      left:145px;
    }
    .pos3{
      position: absolute;
      top:240px;
      left:72px;
      transform: rotate(-20deg);
    }
    .pos4{
      position: absolute;
      top:237px;
      left:218px;
      transform: rotate(15deg);
    }
    .pos5{
      position: absolute;
      top:196px;
      left:97px;
      transform: rotate(-15deg);
    }
    .pos6{
      position: absolute;
      top:254px;
      left:171px;
      transform: rotate(-5deg);
    }
    .pos7{
      position: absolute;
      top:191px;
      left:192px;
      transform: rotate(-20deg);
    }
  }
  .pot-base{
    position: absolute;
    width: 282px;
    height: auto;
    bottom:40px;
    left:47px;
  }
  .float-wow{
    position: absolute;
    width: 340px;
    height: auto;
    bottom:0;
    left:10px;
    z-index: 10011;
  }
  .start-btn{
    position: absolute;
    z-index: 10011;
    width: 220px;
    height: auto;
    bottom:5px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
.result-dialog-shadow{
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  background-color: rgba(0,0,0,0.3);
  z-index: 10000;
}
.result-dialog{
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/11.png);
  background-position: center top;
  background-size: 100% 100%;
  z-index: 10001;
  .banner{
    width: 304px;
    height: auto;
    margin:34px auto 0 auto;
    z-index: 100;
    position: relative;
  }
  .content{
    width: 340px;
    margin:-50px auto 0 auto;
    border-radius: 30px;
    background: rgba(31, 0, 78, 0.55);
    border: 2px solid rgba(255, 255, 255, 1);
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;
    .title{
      font-size: 29px;
      line-height: 42px;
      color: #fff;
      margin: 56px auto 0 auto;
      text-align: left;
      width: 174px;
      &.wid{
        width:213px
      }
      span{
        color: rgba(255, 217, 0, 1);
      }
    }
    .cover{
      background-color: rgba(163, 47, 81, 1);
      border-radius: 16px;
      height: 175px;
      width: 175px;
      display: block;
      margin:12px auto 0 auto;
    }
    .smile{
      position: absolute;
      width: 79px;
      height: 72px;
      top: 134px;
      right: 40px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .cry{
      width: 220px;
      display: block;
      margin: 0 auto 24px auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .name{
      font-size: 14px;
      line-height: 22px;
      color: #fff;
      width: 170px;
      margin:12px auto 13px auto;
    }
    .btn{
      width: 116px;
      height: auto;
    }
    .focus-tips{
      font-size: 12px;
      line-height: 22px;
      margin: 12px 0 16px 0;
      color: #fff;
    }
  }
  .back-btn{
    width: 340px;
    height: auto;
    margin-top: 24px;
  }
}
@keyframes lotteryJumping {
  0%{
    margin-top: 0;
  }
  10%{
    margin-top: -45px;
  }
  20%{
    margin-top: 0;
  }
  30%{
    margin-top: -26px;
  }
  40%{
    margin-top: 0;
  }
  50%{
    margin-top: -14px;
  }
  60%{
    margin-top: 0;
  }
  70%{
    margin-top: -7px;
  }
  80%{
    margin-top: 0;
  }
  95%{
    margin-top: -2px;
  }
  100%{
    margin-top: 0;
  }
}
@keyframes logScroll {
  0%{
    margin-left: 0;
  }
  100%{
    margin-left:-416px;
  }
}
</style>